

import FindDealers
 from './FindDealers';
 
 import History from './History';
 import Footer from './Footer';

function HomepageComponents() {
  return (
   <>
   

<FindDealers></FindDealers>
<History></History>
<Footer></Footer>


   </>
  );
}

export default HomepageComponents;
